import type { LiveVideo } from '../realtime';

export function getLatestRecording(liveVideos: readonly LiveVideo[]): LiveVideo | null {
  let latest: LiveVideo | null = null;
  for (const liveVideo of liveVideos) {
    if (latest === null || Date.parse(liveVideo.startedAtUtc) > Date.parse(latest.startedAtUtc)) {
      latest = liveVideo;
    }
  }
  return latest;
}

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

export function showRecordings(latestRecording: LiveVideo | null, nowMs: number = Date.now()): boolean {
  return latestRecording !== null && nowMs < Date.parse(latestRecording.startedAtUtc) + THREE_DAYS_MS;
}

export function playlistUrl(videoId: string, recordingsRootUrl: string): string {
  const version = Math.random().toString().substring(2);
  return `${recordingsRootUrl}/${videoId}/playlist.m3u8?v=${version}`;
}
